export function CategorySelect({ value, onChange }) {
    const categories = [
        { code: "CAT01", label: "번역/통역 (관공서·비즈니스)" },
        { code: "CAT02", label: "서류 대행/행정 컨설팅 (비자·보험)" },
        { code: "CAT03", label: "독일어/외국어 레슨" },
        { code: "CAT04", label: "IT/개발/데이터" },
        { code: "CAT05", label: "디자인/영상 제작" },
        { code: "CAT06", label: "취업/이직 컨설팅 (독일 CV·면접)" },
        { code: "CAT07", label: "현지 가이드" },
        { code: "CAT08", label: "음악/예체능 레슨" },
        { code: "CAT09", label: "홈케어/수리/이사 지원" },
        { code: "CAT10", label: "비즈니스/마케팅" },
        { code: "CAT11", label: "반려동물 케어 & 산책" },
        { code: "CAT12", label: "라이프스타일 & 심부름" }
    ];

    return (
        <div className="col-md-6 mb-4">
            <label className="form-label fw-semibold text-secondary">카테고리</label>
            <select
                className="form-select border-2 shadow-none"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">카테고리 선택</option>
                {categories.map(cat => (
                    <option key={cat.code} value={cat.code}>
                        {cat.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
